up.compiler('[quick-check]', (element, data) => {
  let submitButton = element.querySelector('[quick-check-submit]')
  let input = element.querySelector('[quick-check-input]').querySelector('input');

  input.focus();

  function submitForm() {
    let searchValue = input.value;
    let url = encodeURI(data.url + '?identifier=' + searchValue)

    up.layer.open({ url: url, mode: "modal", target: '.quick-check', layer: 'current', peel: false, history: false, dismissable: false })
  }

  function init() {
    submitButton.addEventListener('click', submitForm)

    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        submitForm();
      }
    })

    up.on('up:layer:opened', () => {
      input.focus();
    })

    up.on('up:layer:dismissed', () => {
      up.reload('.incoming-invoices')
    })
  }

  init()
})
